module.exports = __webpack_public_path__ + "img/9.6847b92c.jpg";